export default class FileUpload {
  constructor() {
    this.init();
  }
  init() {
    const button = document.getElementById("upload-button");
    const input = document.getElementById("upload-input");

    if (button) {
      button.addEventListener("click", function(e) {
        e.preventDefault();

        const placeholder = this.innerText;
        console.log(placeholder);

        input.click();
      });

      input.addEventListener("change", function() {
        let value = this.value;
        let parts = value.split("\\");
        let fileName = parts.pop();

        if (value != "") {
          button.innerText = fileName;
        } else {
          button.innerText = placeholder;
        }
      });
    }
  }
}
